<template>
  <component :is="giftData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="giftData === undefined">
      <h4 class="alert-heading">獲取購物禮卷數據時出錯</h4>
      <div class="alert-body">
        找不到相關購物禮卷記錄。請查看
        <b-link class="alert-link" :to="{ name: 'gift-list' }">
          購物禮卷列表
        </b-link>
      </div>
    </b-alert>
    <gift-edit-tab-information
      v-if="giftData"
      :customerOptions="customerOptions"
      :gift-data="giftData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- :userOptions="userOptions" -->
    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import giftStoreModule from "../giftStoreModule";
import giftEditTabInformation from "./giftEditTabInformation.vue";

export default {
  components: {
    giftEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const giftData = ref({ id: 0,status:1 });
    const gift = {
      id: 0,
      status:1
    };

    const gift_APP_STORE_MODULE_NAME = "gift";

    if (!store.hasModule(gift_APP_STORE_MODULE_NAME))
      store.registerModule(gift_APP_STORE_MODULE_NAME, giftStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(gift_APP_STORE_MODULE_NAME))
        store.unregisterModule(gift_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "coupon-gift-create") {
        giftData.value = gift;
      } else {
        store
          .dispatch("gift/fetchGift", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            giftData.value = response.data.gift_voucher;
            console.log(giftData.value);
          })
          .catch((error) => {
            console.log("error when fetching gift", error);
            if (error.response.status === 404) {
              giftData.value = undefined;
            }
          });
      }
    };

  // const userOptions = ref([]);
  const customerOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        // users: true,
        customers: true,
      })
      .then((response) => {
        // userOptions.value = response.data.users;
        customerOptions.value = response.data.customers;
        refetchData();
      });
  };

    onMounted(() => {
      refetchOption();
    });

    return {
      giftData,
      // userOptions,
      customerOptions,
      refetchOption,
      refetchData,
    };
  },
};
</script>
